export const PAGE = {
  HEADER: 'page-header',
  HEADER_TITLE: 'page-header-title',
  HEADER_ACTION: 'page-header-action',
};

export const CONFIRM_DIALOG = {
  CONTAINER: 'confirmation-dialog',
  CONFIRM_BUTTON: 'popup-confirm',
  CANCEL_BUTTON: 'popup-cancel',
};

export const TABLE = {
  CONTAINER: 'table-container',
  ROW: 'table-row',
};

export const SIDENAV = {
  DASHBOARD: 'sidenav-dashboard',
  ANNUAL_PLANNER: 'sidenav-annualPlanner',
  COMPANIES: 'sidenav-companies',
  STUDENTS: 'sidenav-students',
  PARENTS: 'sidenav-parents',
  STAFF: 'sidenav-staff',
  GROUPS: 'sidenav-groups',
  MESSAGES: 'sidenav-messages',
  ASSESSMENTS: 'sidenav-assessments',
  REPORTS: 'sidenav-reports',
  ATTENDANCE: 'sidenav-attendance',
  CONDUCT: 'sidenav-conduct',
  EVENTS: 'sidenav-events',
  USERROLES: 'sidenav-userroles',
  SETTINGS: 'sidenav-settings',
  MARKBOOK: 'sidenav-markbook',
  PAYABLE_FEES: 'sidenav-payableFees',
  TIMETABLE: 'timetable-menu-link',
};

export const LIST = {
  ASSESSMENT: 'assessmentList',
};

export const FILE = {
  UPLOADED_FILE_ROW_PREFIX: 'file-uploaded-file',
  DELETE_UPLOADED_FILE_BTN: 'file-uploaded-file-delete-btn',
};

export const MODAL = {
  DELETE: 'modal-delete',
  ARCHIVE: 'modal-archive',
  SAVE_PREVIEW: 'modal-save-preview',
  SUBMIT: 'modal-submit',
};

export const PANEL = { CONTAINER: 'drawer' };

export const COMPANY = {
  NEW_BTN: 'company-new-btn',
  SAVE_BTN: 'company-save-btn',
  DELETE_BTN: 'company-delete-btn',
  CONFIRM_DELETE_BTN: 'company-confirm-delete-btn',
  EDIT_BTN: 'company-edit-btn',
  ROW: 'company-row',
  LINK: 'company-link',
  LIST_TABLE: 'company-list-table',
  LIST_ROW: 'company-list-row',
  ADD_STUDENT_MODAL: 'company-add-student-modal',
  ADD_STUDENT_BTN: 'company-add-student-btn',
  SEARCH_STUDENT_INPUT: 'company-search-student-input',
};

export const NAV = {
  /** Matches data-test-id on the Loading component in libs/style */
  MAIN_LOADER: 'loading',
  /** Standard MUI Skeleton class — all MUI skeletons use this */
  SKELETON_LOADER: 'nav-skeleton-loader',
  SKELETON_LOADER_CSS: '.MuiSkeleton-root',
  MAIN_SKELETON: 'main-skeleton',
  PAGINATION_SKELETON: 'pagination-skeleton',
};

export const NOTIFICATION = {
  CONTAINER: 'notification',
};

export const LOGIN = {
  TITLE: 'login-title',
  LOGIN_BTN: 'login-btn',
};

export const SHARED = {
  SCHOOL_SELECT: 'school-select',
  TRIAL_BANNER: 'trial-banner',
  TRIAL_EXPIRED_DIALOG: 'trial-expired-dialog',
  TRIAL_CONTACT_DIALOG: 'trial-contact-dialog',
  TRIAL_CONTACT_EMAIL: 'trial-contact-email',
};

export const DATE_PICKER = {
  TODAY_BTN: 'date-picker-today-btn',
  DATE_SELECT: 'date-picker-select',
  DATE_INPUT: 'date-picker-input',
  RANGE_SELECT: 'date-range-picker',
  SCHOOL_DATES_SELECT: 'school-dates-select',
  PREV_MONTH_BTN: 'date-picker-prev-month-btn',
  NEXT_MONTH_BTN: 'date-picker-next-month-btn',
};

/** English UI labels for SchoolPeriodsRangeSelect presets (E2E runs English). */
export const DATE_PICKER_LABELS = {
  OTHER_PERIODS: 'Other periods',
} as const;

export const PROFILE = {
  MODAL: 'profile-modal',
  MODAL_HEADER: 'profile-modal-header',
};

export const ATTENDANCE = {
  CREATE_BTN: 'attendance-create-btn',
  ADD_GROUP_BTN: 'attendance-add-group-btn',
  ADD_GROUP_CARD_PREFIX: 'attendance-add-group-card',
  REGISTER_NAME_CELL: 'attendance-register-name-cell',
  GROUP_CELL_PREFIX: 'attendance-group-cell',
  ENTRY_ROW_PREFIX: 'attendance-entry-row',
};

export const GROUP = {
  NAME_INPUT: 'groups-modal-name-input',
  TYPE_PREFIX: 'groups-modal-type',
  SUBJECT_DROPDOWN: 'groups-modal-subject-dropdown',
  TIMETABLE_CODE_INPUT: 'groups-modal-timetable-code-input',
  DESCRIPTION_INPUT: 'groups-modal-description-input',
};

export const MINI_LIST = {
  CONTAINER: 'mini-list',
  SEARCH_INPUT: 'mini-list-search-input',
  ADD_ALL_BTN: 'mini-list-add-all-btn',
};

export const ELEMENT = {
  ROW: 'row',
  CARD: 'card',
};

export const LIST_ROW_COLUMNS: Record<string, string> = {
  icon: 'list-row-icon',
  date: 'list-row-date',
  subject: 'list-row-subject',
  from: 'list-row-from',
  status: 'list-row-status',
  assessment_name: 'list-row-assessment-name',
  report_name: 'list-row-report-name',
  created_by: 'list-row-created-by',
  group_names: 'list-row-group-names',
  due_date: 'list-row-due-date',
  full_name: 'list-row-full-name',
  relation: 'list-row-relation',
  email: 'list-row-email',
  invite_status: 'list-row-invite-status',
  group_name: 'list-row-group-name',
  age_groups: 'list-row-age-groups',
  am_responsible: 'list-row-am-responsible',
  pm_responsible: 'list-row-pm-responsible',
  per_period: 'list-row-per-period',
  timetable: 'list-row-timetable',
  staff_name: 'list-row-staff-name',
  student_name: 'list-row-student-name',
  dob: 'list-row-dob',
  gender: 'list-row-gender',
  attendance_code: 'list-row-attendance-code',
};

export const SECTION_ROW_COLUMNS: Record<string, string> = {
  group_name: 'section-row-group-name',
  attendance_tag: 'section-row-attendance-tag',
};

export const ICON_MAP: Record<string, string> = {
  Close: 'Cross',
  Mismatch: 'Attention2',
  'Arrow down': 'ArrowheadDown',
  Rollback: 'RollBack',
};

export const INVITE_STATUS_MAP: Record<string, string> = {
  'Not invited': 'NotInvited',
  Invited: 'Invited',
  Accepted: 'Accepted',
};

export const SCHEDULE = {
  ITEM: 'schedule-item',
  ITEM_TIME: 'schedule-item-time',
  ITEM_GROUP_NAMES: 'schedule-item-group-names',
  ITEM_ROOM: 'schedule-item-room',
};

export const SCHEDULE_ITEM_COLUMNS: Record<string, string> = {
  start_time_end_time: SCHEDULE.ITEM_TIME,
  group_names: SCHEDULE.ITEM_GROUP_NAMES,
  room: SCHEDULE.ITEM_ROOM,
};

export const DROPDOWN = {
  DASHBOARD: 'dropdown-dashboard-select',
  SCHEDULE: 'dropdown-schedule-select',
  RELATIONSHIP: 'dropdown-relationship-select',
  // Same test-id, two keys on purpose: the e2e dropdown resolver derives the key from the
  // UI label via screaming-snake-case, so the singular "Age group" and plural "Age groups"
  // labels each need their own entry. Do not collapse — it breaks label lookup in e2e.
  AGE_GROUP: 'dropdown-age-group-select',
  AGE_GROUPS: 'dropdown-age-group-select',
  STATUS: 'dropdown-status-select',
  SUBJECT: 'dropdown-subject-select',
  STAFF: 'dropdown-staff-select',
  DEFAULT_ROOM: 'dropdown-default-room-select',
  LIMITED_TO: 'dropdown-limited-to-select',
  GROUP: 'dropdown-group-select',
  HOUSE: 'dropdown-house-select',
  GENDER: 'dropdown-gender-select',
  NATIONALITY: 'dropdown-nationality-select',
  ROOM: 'dropdown-room-select',
  TIMETABLE_STRUCTURE: 'dropdown-timetable-structure-select',
};

export const DROPDOWN_SELECT = {
  CONTENT: 'dropdown-content',
};

export const TIMETABLE = {
  NAME_INPUT: 'timetable-name-input',
  SCHOOL_YEAR_SELECT: 'timetable-school-year-select',
  IMPORT_LINK_PREFIX: 'timetable-import-link',
  CREATE_LINK_PREFIX: 'timetable-create-link',
  MENU_LINK: 'timetable-menu-link',
  INCONSISTENCIES_TABLE: 'timetable-inconsistencies-table',
  INCONSISTENCIES_ROW_PREFIX: 'timetable-inconsistencies-row',
  INCONSISTENCIES_CELL_PREFIX: 'timetable-inconsistencies-cell',
  INCONSISTENCIES_CELL_ERROR: 'timetable-inconsistencies-cell-error',
  INCONSISTENCIES_TAB_ERRORS: 'timetable-inconsistencies-tab-errors',
  INCONSISTENCIES_TAB_WARNINGS: 'timetable-inconsistencies-tab-warnings',
  IMPORT_SELECT_SHEET_MODAL: 'timetable-import-select-sheet-modal',
  SLOT_PREFIX: 'timetable-slot',
};

export const TIMETABLE_STRUCTURE = {
  STRUCTURE_NAME_INPUT: 'tt-structure-name-input',
  PERIOD_NAME_INPUT: 'tt-structure-period-name-input',
  PERIOD_TYPE_PREFIX: 'tt-structure-period-type',
  GRID_ROW_PREFIX: 'tt-structure-grid-row',
  GRID_SLOT_PREFIX: 'tt-structure-grid-slot',
};

export function getGroupTypeTestId(slugOrLabel: string): string {
  const slug = slugOrLabel.trim().toLowerCase();
  return buildTestId(GROUP.TYPE_PREFIX, { slug }, 'slug');
}

/** GroupType enum value (1=Subject, 2=TutorGroup, 3=NoSubject) → test-id. */
export function getGroupTypeTestIdByValue(typeValue: number): string {
  const slug = { 1: 'subject', 2: 'tutor-group', 3: 'no-subject' }[typeValue] ?? 'unknown';
  return buildTestId(GROUP.TYPE_PREFIX, { slug }, 'slug');
}

export function buildTestId<T extends object>(
  prefix: string,
  item: T,
  ...keys: (keyof T & string)[]
): string {
  for (const key of keys) {
    const value = item[key];
    if (typeof value === 'string' && value) {
      return `${prefix}-${value.replace(/\s+/g, '-')}`;
    }
  }
  return `${prefix}-unknown`;
}
